var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcInstagram = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.50098C0 1.57098 1.56952 0 3.49902 0H8.49902C10.429 0 12 1.56952 12 3.49902V8.49902C12 10.429 10.4305 12 8.50098 12H3.50098C1.57098 12 0 10.4305 0 8.50098V3.50098ZM10 2.49922C10 2.22322 9.776 1.99922 9.5 1.99922C9.224 1.99922 9 2.22322 9 2.49922C9 2.77522 9.224 2.99922 9.5 2.99922C9.776 2.99922 10 2.77522 10 2.49922ZM6 3C7.6545 3 9 4.3455 9 6C9 7.6545 7.6545 9 6 9C4.3455 9 3 7.6545 3 6C3 4.3455 4.3455 3 6 3ZM4.00005 6.00078C4.00005 4.89621 4.89548 4.00078 6.00005 4.00078C7.10462 4.00078 8.00005 4.89621 8.00005 6.00078C8.00005 7.10535 7.10462 8.00078 6.00005 8.00078C4.89548 8.00078 4.00005 7.10535 4.00005 6.00078Z",
    fill: "#B3B3B3"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcInstagram, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-instagram.b2336f85.svg";
export { ForwardRef as ReactComponent };